import { cn } from "@/lib/utils";

/**
 * The Chama mark: a ring of beads (the circle a chama forms) around a
 * lightning bolt, in shuka red, highland green, and savanna gold.
 */
export function ChamaLogo({ className }: { className?: string }) {
  const beads = Array.from({ length: 8 }, (_, i) => {
    const angle = ((i * 45 - 90) * Math.PI) / 180;
    return {
      x: 32 + 18 * Math.cos(angle),
      y: 32 + 18 * Math.sin(angle),
      red: i % 2 === 0,
    };
  });
  return (
    <svg viewBox="0 0 64 64" className={cn("size-8", className)} aria-hidden="true">
      {beads.map((b, i) => (
        <circle
          key={i}
          cx={b.x}
          cy={b.y}
          r="5"
          className={b.red ? "fill-primary" : "fill-accent"}
        />
      ))}
      <path
        d="M34.8 21.5 L25.5 33.4 h5.7 L28.6 43.5 L40.2 29.8 h-6.1 L36.9 21.5 Z"
        className="fill-gold"
      />
    </svg>
  );
}

export function ChamaWordmark({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <ChamaLogo className="size-8" />
      <span className="font-display text-xl font-semibold tracking-tight">
        Chama<span className="text-primary"> Chat</span>
      </span>
    </span>
  );
}
